import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import routes from './routes'

export const createSMWRouter = (mode = 'html5') =>
  createRouter({
    history: mode === 'hash' ? createWebHashHistory() : createWebHistory(),
    routes
  })
